<template>
  <v-defaults-provider :defaults="defaults">
    <transition name="nav-fade">
      <component
        :is="layout"
        v-if="layout"
      >
        <router-view v-slot="{ Component, route }">
          <transition name="nav-fade">
            <!-- Div is needed to force root element for transition -->
            <div
              :key="route.path"
              class="fill-height"
            >
              <component :is="Component" />
            </div>
          </transition>
        </router-view>
      </component>
    </transition>
  </v-defaults-provider>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { capitalize } from "lodash"
import { StatusBar } from '@capacitor/status-bar'
import { SplashScreen } from '@capacitor/splash-screen'
import gtm from "@/mixins/gtm"
import {Capacitor} from "@capacitor/core"

export default defineComponent({
  head() {
    return {
      titleTemplate: "%s | " + import.meta.env.VITE_APP_NAME,
      title: this.$route?.meta?.title || capitalize(this.$route?.name as string).replace('-', ' ') || undefined
    }
  },
  computed: {

    /**
     * Defaults for Vuetify components
     */
    defaults(): object {
      return {
        VTooltip: {
          closeOnContentClick: true, // force close if "tap"
          openOnClick:         false, // disable "taps" to open tooltips
          openOnFocus:         !this.$vuetify.display.mdAndDown, // force tooltips to be blocked on mobile
          openOnHover:         !this.$vuetify.display.mdAndDown, // force tooltips to be blocked on mobile
          openDelay:           500, // force a delay to disable "taps" to open tooltips
        },
      }
    },

    layout(): string | null{
      if (!this.$route) return null
      return this.$route.meta?.layout ? this.$route.meta.layout + "Layout" : "EmptyLayout"
    },
  },
  mixins: [gtm],

  beforeCreate() {
    if (Capacitor.isNativePlatform()) {
      StatusBar.hide()
    }
  },
  mounted() {
    if (Capacitor.isNativePlatform()) {
      SplashScreen.hide()
    }
    this.trackFirstLanding()
  }
})
</script>

<style lang="scss">
.nav-fade-enter-active,
.nav-fade-leave-active {
  transition: opacity 0.3s ease;
}

.nav-fade-leave-active {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
}

.nav-fade-leave-to {
  opacity: 0;
}
</style>
